import { SVGInterface } from "../../interface";

const Measure = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20.8391 7.40127C21.2291 7.01127 21.2291 6.38127 20.8391 5.99128L18.0091 3.16127C17.6191 2.77127 16.9891 2.77127 16.5991 3.16127L12.1091 7.65127L8.21914 3.76127C7.43914 2.98127 6.16914 2.98127 5.38914 3.76127L3.48914 5.66127C2.70914 6.44128 2.70914 7.71127 3.48914 8.49127L7.37914 12.3813L2.86914 16.8913V21.1313H7.10914L11.6291 16.6113L15.5191 20.5013C16.4691 21.4513 17.7491 21.1013 18.3491 20.5013L20.2491 18.6013C21.0291 17.8213 21.0291 16.5513 20.2491 15.7713L16.3591 11.8813L20.8391 7.40127ZM4.90914 7.07127L6.79914 5.17127L8.06914 6.44127L6.88914 7.63127L8.29914 9.04128L9.48914 7.85127L10.6891 9.05128L8.78914 10.9513L4.90914 7.07127ZM16.1391 14.5113L14.9491 15.7013L16.3591 17.1113L17.5491 15.9213L18.8191 17.1913L16.9191 19.0913L13.0291 15.2013L14.9291 13.3013L16.1391 14.5113ZM6.27914 19.1313H4.86914V17.7213L14.4791 8.11127L15.8891 9.52128L6.27914 19.1313ZM15.8891 6.69127L17.2991 5.28127L18.7091 6.69127L17.2991 8.10127L15.8891 6.69127Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Measure;
